"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Outputs = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var Outputs = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Outputs, _React$Component);

  function Outputs() {
    (0, _classCallCheck2["default"])(this, Outputs);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Outputs).apply(this, arguments));
  }

  (0, _createClass2["default"])(Outputs, [{
    key: "render",
    value: function render() {
      if (this.props.hidden) {
        return null;
      }

      if (this.props.children) {
        return React.createElement("div", {
          className: "jsx-4038584223" + " " + "outputs".concat(this.props.expanded ? " expanded" : "")
        }, this.props.children, React.createElement(_style["default"], {
          styleId: "4038584223",
          css: ".outputs.jsx-4038584223{padding:10px 10px 10px calc(var(--prompt-width,50px) + 10px);word-wrap:break-word;overflow-y:hidden;outline:none;max-height:600px;text-overflow:ellipsis;}.expanded.jsx-4038584223{max-height:100%;}.outputs.jsx-4038584223 a{color:var(--link-color-unvisited,blue);}.outputs.jsx-4038584223 a:visited{color:var(--link-color-visited,blue);}.outputs.jsx-4038584223>div:empty{display:none;}.outputs.jsx-4038584223 code{font-family:\"Source Code Pro\";white-space:pre-wrap;font-size:14px;}.outputs.jsx-4038584223 pre{white-space:pre-wrap;font-size:14px;word-wrap:break-word;}.outputs.jsx-4038584223 img{display:block;max-width:100%;}.outputs.jsx-4038584223 kbd{display:inline-block;border:1px solid #ccc;border-radius:4px;padding:0.1em 0.5em;margin:0 0.2em;box-shadow:0 1px 0px rgba(0,0,0,0.2),0 0 0 2px #fff inset;background-color:#f7f7f7;}.outputs.jsx-4038584223 table{border-collapse:collapse;}.outputs.jsx-4038584223 th,.outputs.jsx-4038584223 td,.outputs.jsx-4038584223 .th,.outputs.jsx-4038584223 .td{padding:0.5em 1em;border:1px solid var(--theme-app-border,#cbcbcb);}.outputs.jsx-4038584223 th{text-align:left;}.outputs.jsx-4038584223 blockquote{padding:0.75em 0.5em 0.75em 1em;background:var(--theme-cell-output-bg,white);border-left:0.5em solid #ddd;}.outputs.jsx-4038584223 .blockquote::before{display:block;height:0;content:\"\u201C\";margin-left:-0.95em;font:italic 400%/1 Open Serif,Georgia,\"Times New Roman\",serif;color:solid var(--theme-app-border,#cbcbcb);}.outputs.jsx-4038584223 blockquote p.jsx-4038584223{display:inline;}.outputs.jsx-4038584223 dd{display:block;-webkit-margin-start:40px;}.outputs.jsx-4038584223 dl{display:block;-webkit-margin-before:1__qem;-webkit-margin-after:1em;-webkit-margin-start:0;-webkit-margin-end:0;}.outputs.jsx-4038584223 dt{display:block;}.outputs.jsx-4038584223 dl{width:100%;overflow:hidden;padding:0;margin:0;}.outputs.jsx-4038584223 dt{font-weight:bold;float:left;width:20%;padding:0;margin:0;}.outputs.jsx-4038584223 dd{float:left;width:80%;padding:0;margin:0;}.outputs.jsx-4038584223 .list-inline li.jsx-4038584223{display:inline;padding-right:20px;text-align:center;}"
        }));
      }

      return null;
    }
  }]);
  return Outputs;
}(React.Component);

exports.Outputs = Outputs;
(0, _defineProperty2["default"])(Outputs, "defaultProps", {
  children: null,
  expanded: false,
  hidden: false
});